// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"292d50fc46eb0d0c7713","883":"c9881567519606a27e31"}[chunkId] + ".js";
};